module.exports = __webpack_public_path__ + "static/media/thumbnail-large.672bdb17.svg";